export default "__VITE_ASSET__Dv8wP3qP__"